import VueRouter from 'vue-router'

import { requireOrganizationMembership, requirePermissions } from '@/helpers/router-guard-helpers'
import { MyActiveOrganization, initializeMyAccount } from '@/helpers/my-account-helper'

const Home = () => import('@/views/Home')
const Logout = () => import('@/views/Logout')
const InsightsHome = () => import('@/views/insights/InsightsHome')
const ManageAccount = () => import('@/views/manage/ManageAccount')
const ManageUsers = () => import('@/views/manage/ManageUsers')
const ManageNotificationPreferences = () => import('@/views/manage/ManageNotificationPreferences')
const Privacy = () => import('@/views/support/Privacy')
const Terms = () => import('@/views/support/Terms')
const AppVersion = () => import('@/views/support/AppVersion')
const NoMembership = () => import('@/views/support/NoMembership')
const NotFound = () => import('@/views/support/NotFound')
const PatientSearchList = () => import('@/views/search/PatientSearchList')

export function ClinicalRouter(vuexStore) {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: requireOrganizationMembership
      },
      {
        path: '/org/:orgId/manage/users',
        name: 'manage-users',
        component: ManageUsers,
        props: true,
        beforeEnter(to) {
          window.location = `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${to.params.orgId}/manage/users`
        }
      },
      {
        path: '/org/:orgId/insights',
        name: 'insights',
        component: InsightsHome,
        props: true,
        beforeEnter: requireOrganizationMembership
      },
      {
        path: '/org/:orgId/patients',
        beforeEnter(to) {
          window.location = `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/org/${to.params.orgId}/patients`
        }
      },
      {
        path: '/org/:orgId/patient-search-list',
        name: 'patient-search-list',
        component: PatientSearchList,
        props: route => ({
          searchString: route.query.searchString,
          pageNumber: Number(route.query.pageNumber),
          itemsPerPage: Number(route.query.itemsPerPage),
          sortField: route.query.sortField,
          orgId: route.params.orgId
        }),
        beforeEnter: requireOrganizationMembership
      },
      {
        path: '/logout',
        name: 'logout',
        component: Logout
      },
      {
        path: '/terms',
        name: 'terms',
        component: Terms
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: Privacy
      },
      {
        path: '/account',
        name: 'account',
        component: ManageAccount,
        beforeEnter() {
          window.location = `${window.$appConfig.VUE_APP_PLATFORM_UI_URL}/account`
        }
      },
      {
        path: '/account/trial-notification-prefs',
        name: 'trial-notification-preferences',
        component: ManageNotificationPreferences
      },
      {
        path: '/version',
        name: 'version',
        component: AppVersion
      },
      {
        path: '/no-membership',
        name: 'no-membership',
        component: NoMembership
      },
      {
        path: '/**',
        name: 'not-found',
        component: NotFound
      }
    ]
  })

  router.beforeEach((to, _from, next) => {
    if (to.params['orgId'] && to.params['orgId'] !== MyActiveOrganization.id)
      initializeMyAccount({ newOrgId: to.params['orgId'] }).then(() => {
        next()
      })
    else next()
  })

  return router
}
